module.exports = __webpack_public_path__ + "static/img/szafa_42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_42.svg
// module id = b9p9
// module chunks = 0